/* global $:false */

import 'jquery-ui/sortable.js'

export default class SidebarContentBlockSlugs {
  static init () {
    this.el = $('#sidebar-content-blocks')
    if (!(this.el.length > 0)) { return }
    $('#sidebar-content-block-slugs').sortable()

    this.contentBlocks = this.el.find('#sidebar-content-block-slugs')
    this.updateUrl = this.el.data('update-url')

    this.contentBlocks.on('sortupdate', (e, ui) => {
      this.updateBlocks()
    })
  }

  static updateBlocks () {
    $.ajax(
      this.updateUrl, {
        type: 'PUT',
        dataType: 'json',
        data: { sidebar_content_block_slugs: $('#sidebar-content-block-slugs').sortable('toArray', { attribute: 'data-slug' }) },
        success: data => {
          $('#preview').load(window.location + ' #preview')
        }
      }
    )
  }
}
